import { render, staticRenderFns } from "./CompAwardRow.vue?vue&type=template&id=29ff32b2&scoped=true&"
import script from "./CompAwardRow.vue?vue&type=script&lang=js&"
export * from "./CompAwardRow.vue?vue&type=script&lang=js&"
import style0 from "./CompAwardRow.vue?vue&type=style&index=0&id=29ff32b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff32b2",
  null
  
)

export default component.exports